import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
//import {observable} from 'mobx';
import {
    HashRouter as Router,
    Switch,
    Route,
    Link
} from 'react-router-dom'
import asyncComponent from "./components/AsyncComponent";
//styles
import './App.scss';
import './Custom.scss';
import WxCommon from "./components/Wx/Common";
//routes
//const FrontPage = asyncComponent(()=>import("./pages/FrontPage/FrontPage"));

const Detail = asyncComponent(()=>import("./pages/Detail/Detail"));
const Me = asyncComponent(()=>import("./pages/Me/Me"));
const PreOrder = asyncComponent(()=>import("./pages/Me/PreOrder"));
const MyGallery = asyncComponent(()=>import("./pages/Me/MyGallery"));
const MyFav = asyncComponent(()=>import("./pages/Me/MyFav"));
const MyJigsaw = asyncComponent(()=>import("./pages/Me/MyJigsaw"));
const Index = asyncComponent(()=>import("./pages/Index/Index"));
const Test = asyncComponent(()=>import("./pages/Index/Test"));
const JigsawPreview = asyncComponent(()=>import("./pages/Detail/JigsawPreview"));
const MyAlbum = asyncComponent(()=>import("./pages/Me/MyAlbum"));
const TheAlbum = asyncComponent(()=>import("./pages/Me/TheAlbum"));
const VideoPage = asyncComponent(()=>import("./pages/Video/VideoPage"));
const FrontPage = asyncComponent(()=>import("./pages/FrontPage/FrontPage"));
const SendPack = asyncComponent(()=>import("./pages/RedPack/SendPack"));
const RedPackDetail = asyncComponent(()=>import("./pages/RedPack/RedPackDetail"));

const FP = function ({history, match}) {
    return <Index history={history} params={match.params}><FrontPage history={history} params={match.params}/></Index>
}

//modules
@inject("rootStore")
@observer
class App extends Component {


    render() {
        //this.props.rootStore.galleryStore.echo("hello");
        return (
            <Router>
                <React.Fragment>
                    <Switch>
                        <Route path="/frontpage/:id/:current" component={FP}/>
                        <Route path="/frontpage/:id" component={FP}/>
                        <Route path="/detail/:id" component={({history, match})=><Index history={history} params={match.params}><Detail history={history}/></Index>}/>
                        <Route path="/me" component={Me}/>
                        <Route path="/preorder" component={PreOrder}/>
                        <Route path="/mygallery" component={MyGallery}/>
                        <Route path="/myfav" component={MyFav}/>
                        <Route path="/myjigsaw" component={MyJigsaw}/>
                        <Route path="/myalbum" component={MyAlbum}/>
                        <Route path="/album/:keyword/ocr" component={TheAlbum}/>
                        <Route path="/album/:personid/image/:imageid" component={TheAlbum}/>
                        <Route path="/album/:personid" component={TheAlbum}/>
                        <Route path="/preview/:url" component={JigsawPreview}/>
                        <Route path="/video/:galleryid/:id/:url" component={VideoPage}/>
                        <Route path="/test" component={Test}/>
                        <Route path="/send" component={SendPack}/>
                        <Route path="/redpack/:id" component={RedPackDetail} />
                        <Route path="/" component={FP}/>
                    </Switch>
                    <WxCommon/>
                </React.Fragment>

            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js